import * as React from 'react'
import { compose } from 'redux'
import cookie from 'js-cookie'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Title, Button } from 'relevant-ui'
import { Props } from './types'

import './styles.scss'

const RedirectUser = ({ location }: Props) => {
  if (!cookie.get(process.env.COOKIES_AUTHORIZATION_TOKEN as string)) {
    const redirect = location.search.split('callback_url=')[1]
    return window.open(
      `https://connect-stg.bliink.io?redirect=https://connect-stg.bliink.io/connect?callback_url=${redirect}`,
    )
  }

  const onHandleRedirectUser = () => {
    const localhostRegex = /^http:\/\/localhost/
    const vercelRegex = /vercel/g

    const redirect = location.search.split('callback_url=')[1]
    const url = `${redirect}`

    if (localhostRegex.test(redirect) || vercelRegex.test(redirect)) {
      window.open(
        `${url}?token=${cookie.get(
          process.env.COOKIES_AUTHORIZATION_TOKEN as string,
        )}`,
        '_blank',
      )
    } else {
      window.open(url, '_blank')
    }

    cookie.set('user_auth_dev', cookie.get('user_auth_stg') as any, {
      domain: 'localhost',
    })
  }

  const onHandleRedirectUserToHomePage = () => {
    window.location.href = '/home'
  }

  return (
    <div className="container">
      <Title title="Souhaitez-vous être redirigé vers l'application ?" />
      <div className="buttons">
        <div className="buttons__btn">
          <Button
            label="Accéder à l'application"
            size="large"
            type="submit"
            button="primary"
            onClick={onHandleRedirectUser}
          />
        </div>
        <div className="buttons__btn">
          <Button
            label="Annuler"
            size="large"
            type="submit"
            button="secondary"
            onClick={onHandleRedirectUserToHomePage}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: any) => {
  const { user } = state

  return {
    user: {
      user,
    },
  }
}

export default compose(withRouter, connect(mapStateToProps))(RedirectUser)
